<template>
  <div @touchmove.prevent>
    <div :class="$style.box">
      <div
        :class="$style.content"
        :style="{ backgroundImage: `url('${$cdnUrl}/dragonCity/dialog_bg_1.png')` }"
      >
        <img :class="$style.title" :src="`${$cdnUrl}/dragonCity/word_2_get.png`" />
        <img :class="$style.icon" :src="giftList[sort]['image']" />
        <p>{{ giftList[sort]['content'][0] }}</p>
        <p>{{ giftList[sort]['content'][1] }}</p>
        <p>礼包码：{{ code }}</p>
        <div>
          <div class="copyBtn">复制礼包码</div>
          <div @click="$emit('closeGift')">取消</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { giftList } from '../dragonCity/config';
import Clipboard from 'clipboard';

export default {
  props: {
    code: {
      type: String,
      default: '',
    },
    sort: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      giftList: giftList,
    };
  },
  created() {
    this.copyInit();
  },
  methods: {
    copyInit() {
      // 礼包领取成功弹窗中点击复制
      this.copy = new Clipboard('.copyBtn', {
        text: () => {
          return this.code;
        },
      });
      this.copy.on('success', (e) => {
        this.$toast.success('复制成功');
      });
    },
  },
};
</script>

<style lang='scss' module>
.box {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 10;
  overflow: hidden;

  .content {
    width: 350px;
    height: 280px;
    background-repeat: no-repeat;
    background-size: 100%;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 140px;

    .title {
      width: 100px;
      position: absolute;
      left: 50%;
      transform: translateX(-46%);
      top: 5px;
    }
    .icon {
      width: 120px;
      position: absolute;
      left: 50%;
      transform: translateX(-46%);
      top: 40px;
    }
    > p {
      width: 100%;
      text-align: center;
      font-size: 8px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #3f0a0c;
      line-height: 9px;
      opacity: 0.74;
      position: absolute;
    }
    > p:nth-child(3) {
      top: 160px;
    }
    > p:nth-child(4) {
      top: 174px;
    }
    > p:nth-child(5) {
      font-size: 12px;
      line-height: 7px;
      font-weight: bold;
      top: 194px;
    }
    > div {
      width: 100%;
      height: 30px;
      position: absolute;
      bottom: 36px;
      // background-color: pink;
      display: flex;
      justify-content: space-between;
      padding: 0px 42px;
      > div {
        width: 99px;
        height: 26px;
        border: 1px solid #3f0a0c;
        border-radius: 3px;
        text-align: center;
        line-height: 26px;
        font-size: 9px;
        font-family: FZDaBiaoSong-B06S;
        font-weight: bold;
        color: #3f0a0c;
        box-sizing: content-box;
      }
      > div:nth-child(1) {
        background: #3f0a0c;
        color: #f4ce86;
      }
    }
  }
}
</style>